// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 618) return "static/chunks/618.ba95d0c9d184e179.js";
	if (chunkId === 54) return "static/chunks/54.b090d21976211ca9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"225":"57671f315ae3f6d7","528":"93a1c98a6e4d6a38","704":"7a39f83f8b62f786","812":"14bc97d1c30cd567","939":"163c022470a9e51a","979":"6d01c81df8ab43bd"}[chunkId] + ".js";
};